export interface Plan {
  name: string;
  tag: string;
  price: string;
  sub: string;
  features: string[];
}

export interface PlanExtra {
  nameKey: string;
  descriptionKey: string;
  price: string;
}

export interface PlanExtraSection {
  titleKey: string;
  subtitleKey: string;
  extras: PlanExtra[];
}

export const plans: Plan[] = [
  {
    name: "Semilla",
    tag: "Inicio sin riesgo",
    price: "GRATIS",
    sub: "/ siempre",
    features: [
      "Diseño One Page",
      "Botón de WhatsApp",
      "Seguridad SSL",
      "Hosting incluido",
      "Sin dominio propio",
    ],
  },
  {
    name: "Brota",
    tag: "Recomendado",
    price: "25€ + IVA",
    sub: "/ mes",
    features: [
      "Diseño Multi-página",
      "Sal en Google (SEO)",
      "Dominio .com/.es incluido",
      "5 correos profesionales",
      "Blindaje legal completo",
    ],
  },
  {
    name: "Personalizado",
    tag: "A medida",
    price: "Consultar",
    sub: "presupuesto",
    features: [
      "Ingeniería de software",
      "Integraciones CRM/ERP",
      "Intranet corporativa",
      "App móvil híbrida",
      "Soporte avanzado",
    ],
  },
];

export const brotaExtrasSections: PlanExtraSection[] = [
  {
    titleKey: "extras.sections.global.title",
    subtitleKey: "extras.sections.global.subtitle",
    extras: [
      {
        nameKey: "extras.sections.global.extras.multiIdiomaIa1.name",
        descriptionKey: "extras.sections.global.extras.multiIdiomaIa1.description",
        price: "+10€ / mes",
      },
      {
        nameKey: "extras.sections.global.extras.multiIdiomaIa2.name",
        descriptionKey: "extras.sections.global.extras.multiIdiomaIa2.description",
        price: "+15€ / mes",
      },
    ],
  },
  {
    titleKey: "extras.sections.analytics.title",
    subtitleKey: "extras.sections.analytics.subtitle",
    extras: [
      {
        nameKey: "extras.sections.analytics.extras.monthlyStats.name",
        descriptionKey: "extras.sections.analytics.extras.monthlyStats.description",
        price: "+5€ / mes",
      },
    ],
  },
];
